import _extends from "@babel/runtime/helpers/extends";
import cx from 'classnames';
import React, { forwardRef } from 'react';
var Input = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement("input", _extends({}, props, {
    className: cx('rbt-input-main', props.className),
    ref: ref
  }));
});
export default Input;